<template>
    <div class="container px-0">
        <!-- <div v-if="!profile" class="row">
            <div class="col-12">
                <div class="weekly-sheets-page--header">
                    <div class="weekly-sheets-page--header-item">
                        <h1 class="weekly-sheets-page--header-item-title">{{makeHoursReadable(total_hours)}} hrs</h1>
                        <h6 class="weekly-sheets-page--header-item-subtitle">Total hours worked</h6>
                    </div>
                    <div class="weekly-sheets-page--header-item">
                        <h1 class="weekly-sheets-page--header-item-title">{{makeHoursReadable(avg_hours)}} hrs</h1>
                        <h6 class="weekly-sheets-page--header-item-subtitle">Avg Hours worked per operative</h6>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="row mt-4">
			<div class="col-12" v-if="form_submission.status">
				<h6 class="text-danger" v-bind:class="profile ? 'pl-2' : ''">
					This week sheet was made invalid by a newer version.
				</h6>
			</div>
            <div class="col-12">
                <div class="flex-table" v-bind:class="form_submission.status ? 'invalid' : ''">
                    <div class="weekly-sheets-page--calendar">
                        <div class="weekly-sheets-page--calendar-header weekly-sheets-page--calendar-row">
                            <div class="weekly-sheets-page--calendar-row-item week">{{form_submission.weekly_time_sheets[0].week_date_formatted}}</div>
                            <div class="weekly-sheets-page--calendar-row-item">Mon</div>
                            <div class="weekly-sheets-page--calendar-row-item">Tue</div>
                            <div class="weekly-sheets-page--calendar-row-item">Wed</div>
                            <div class="weekly-sheets-page--calendar-row-item">Thu</div>
                            <div class="weekly-sheets-page--calendar-row-item">Fri</div>
                            <div class="weekly-sheets-page--calendar-row-item">Sat</div>
                            <div class="weekly-sheets-page--calendar-row-item">Sun</div>
                            <div class="weekly-sheets-page--calendar-row-item hours">Total Hrs</div>
                        </div>

                        <div v-for="sheet in form_submission.weekly_time_sheets" v-if="(profile && profile.id === sheet.user.id) || !profile" class="weekly-sheets-page--calendar-row">
                            <div class="weekly-sheets-page--calendar-row-item user people-list--item-title">
                                <h6 class="people-list--item-title-name">{{sheet.user.full_name}}</h6>
                                <h6 class="people-list--item-title-email">{{sheet.user.email}}</h6>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Mon</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.monday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Tue</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.tuesday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Wed</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.wednesday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Thu</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.thursday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Fri</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.friday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Sat</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.saturday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Sun</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sheet.sunday)}}</div>
                            </div>
                            <div class="weekly-sheets-page--calendar-row-item hours">
                                <div class="weekly-sheets-page--calendar-row-item-sm">Total Hrs</div>
                                <div class="weekly-sheets-page--calendar-row-item-val">{{makeHoursReadable(sumHours(sheet))}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: "WeeklySheetSubmission",
        props: [
            'form_submission',
            'job',
			'profile'
        ],

		methods: {
            makeHoursReadable(hours){
                const point_hours = (hours % 1);
                const minutes = Math.round(point_hours * 60);

                return Math.floor(hours) + ':' + (minutes > 9 ? minutes : '0' + minutes);
            },
            sumHours(record){
                return record.monday +
                    record.tuesday +
                    record.wednesday +
                    record.thursday +
                    record.friday +
                    record.saturday +
                    record.sunday;
            }
		},

        computed: {
			total_hours (){
				let sum = 0;
				this.form_submission.weekly_time_sheets.forEach(function (sheet){
					sum += sheet.monday + sheet.tuesday + sheet.wednesday + sheet.thursday + sheet.friday + sheet.saturday + sheet.sunday;
				});

				return sum;
            },

            avg_hours(){
				return (this.total_hours / 7 / this.form_submission.weekly_time_sheets.length).toFixed(1);
            }
        }
	}
</script>
